import {createFileRoute} from '@tanstack/react-router';
import {DepositApplicationChooseProductPage} from 'features/deposit/onboarding/pages/DepositApplicationChooseProductPage';

export const Route = createFileRoute(
  '/_protected/deposit-onboarding/choose-product',
)({
  component: DepositApplicationChooseProductPage,
  validateSearch: (search) => {
    return {
      unavailableProduct: search.unavailableProduct as string | undefined,
      productCode: search.productCode as string | undefined,
    };
  },
});
